import { Icon, IconProps } from "./Icon";

export function IconDesert(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M0 23h24v1.01H0zm5-5h1v4h1v-5H5a4 4 0 0 1-4-4V8.19a1 1 0 0 1 1-1 1 1 0 0 1 1 1v4.75A2 2 0 0 0 5 15h2V2a1 1 0 0 1 1-1 1 1 0 0 1 1 1v8h1.93A2.07 2.07 0 0 0 13 8V5.57a1.05 1.05 0 0 1 1-1 1 1 0 0 1 1 1V8a4.12 4.12 0 0 1-4.08 4H9v10h1v-3.58l8.91-7.13 4.36 4.64.73-.69-5-5.31-9 7.2V13h.92A5.14 5.14 0 0 0 16 8V5.57a2 2 0 0 0-2-2 2.06 2.06 0 0 0-2 2V8a1.07 1.07 0 0 1-1.06 1H10V2a2 2 0 0 0-2-2 2 2 0 0 0-2 2v12H5a1 1 0 0 1-1-1.05V8.19a2 2 0 0 0-2-2 2 2 0 0 0-2 2v4.75A5 5 0 0 0 5 18ZM21 6a3 3 0 1 0-3-3 3 3 0 0 0 3 3Zm0-5a2 2 0 1 1-2 2 2 2 0 0 1 2-2Z" />
    </Icon>
  );
}
